import styles from "./ConfirmationModal.module.css";

interface Props {
    title: string;
    prompt: string;
    onOk: () => void;
    onCancel: () => void;
}

export default function ConfirmationModal({
    title,
    prompt,
    onOk,
    onCancel,
}: Props) {
    return (
        <div className={styles.confirmationModal}>
            <div className={styles.modalTitle}>{title}</div>
            <div className={styles.modalPrompt}>
                {prompt.split(/(\\r)?\\n/g).map((s: string) => (
                    <div>{s}</div>
                ))}
            </div>
            <div className={styles.buttonRow}>
                <button onClick={() => onOk()} style={{ flex: 1 }}>
                    OK
                </button>
                <button onClick={() => onCancel()} style={{ flex: 1 }}>
                    Cancel
                </button>
            </div>
        </div>
    );
}
